import { useSubconfigurationNavigationApi } from "../CustomSubconfigurationNavigation/SubconfigurationNavigationApi";

import { type JSX, ReactNode } from "react";

import CardActionArea from "@mui/material/CardActionArea";
import {
  useCsAttribute,
  useCsAttributeApi,
  useCsValue,
  useLocalOptionSelected,
} from "@plansoft-configuration-renderer/framework";

/**
 * Props for {@linkcode ThumbnailActionArea}
 * @category UI
 */
export interface ThumbnailActionAreaProps {
  children?: ReactNode;
  nextAfterSelection?: boolean;
}

/**
 * Renders basic wrapper around the content
 *
 * @category UI
 */
export function ThumbnailActionArea(
  props: ThumbnailActionAreaProps,
): JSX.Element {
  const attribute = useCsAttribute();
  const value = useCsValue();
  const { toggleOption } = useCsAttributeApi();
  const { next } = useSubconfigurationNavigationApi();

  const isSelected = useLocalOptionSelected();

  const isDisabled = Boolean(
    attribute.isReadOnly ||
    !attribute.isAllowed ||
    !value.isAllowed ||
    !value.isActive,
  );

  const handleClick = async (): Promise<void> => {
    await toggleOption(value.value, !isSelected);
    if (props.nextAfterSelection === true && !isSelected === true) {
      next();
    }
  };

  return (
    <CardActionArea
      component="div"
      disabled={isDisabled}
      sx={{ height: "100%" }}
      onClick={handleClick}
    >
      {props.children}
    </CardActionArea>
  );
}
